module.exports = __webpack_public_path__ + "img/box3.45ad58ff.png";